import { Injectable, Injector, inject } from '@angular/core';
import { TransactionDetailsService } from '@foo/foo-framework/shared-modules';

@Injectable({
  providedIn: 'root'
})
export class CustomTransactionDetailsService extends TransactionDetailsService {

  constructor() {
    super();
  }

  transformData(data, category, roles) {
    console.log(data, category);
    if (data.length > 0) {
      const serviceTransformData = this.checkService('transformData', [data,category,roles]);
      if (serviceTransformData) {
        return serviceTransformData;
      }
      this.getCustomValuesData(data);
      if (category === 'payment_controls') {
        return this.getPaymentControlsData(data);
      }
      if (data[0].action === 'delete') {
        if(data[0].key == "aae_feature_access" && category == "cardCatalogue"){
          return this.getDeleteInfoWhiteListed(data);
        }
        return this.getDeleteInfo(data);
      }
      if (data[0].action === 'edit' || data[0].action === 'add') {
        data[0].description_transaction = this.getDescriptionItem(data[0], category);
      }
      if (category === 'generalConf' || category === 'settings') {
        return this.getGeneralConfigurationData(data);
      }
      if (category === 'crypto_config') {
        return this.getCryptoConfigurationData(data);
      } else if (category === 'customer') {
        return this.getCustomerData(data);
      } else if (category === 'cmsUsers') {
        return this.getPendingCMSUserData(data, roles);
      } else if (category === 'branches' || category === 'ATMs' || category === 'locations' || category === 'subregions') {
        return this.getPendingBranchData(data);
      } else if (category === 'app_mode') {
        return this.getPendingAppModeData(data);
      } else if (category === 'pages' || category === 'content_management') {
        return this.getPendingPagesModeData(data);
      } else if (category === 'templates') {
        return this.getPendingTemplates(data);
      } else if (category === 'update_rules') {
        return this.getPendingRules(data);
      } else if (category === 'notification') {
        return this.getPendingNotifications(data);
      } else if (category === 'system_configuration') {
        return this.getSystemConfigurationData(data);
      } else if (category === 'sva_accounts') {
        return this.getSvaAccountsData(data);
      } else if (category === 'departments') {
        return this.getPendingDepartmentData(data);
      } else if (category === 'employees') {
        return this.getPendingEmployeeData(data);
      } else if (data[0]?.key === 'cardgroups') {
        return this.getPendingCardGroupstData(data);
      } else if (data[0]?.key === 'cardtypes') {
        return this.getPendingCardTypesData(data);
      } else if (category === 'cards') {
        return this.getPendingCardsData(data);
      } else if (category === 'companies') {
        return this.getPendingCompaniesData(data);
      }
      else if (category === 'transfers') {
        return this.getPendingTransfersData(data);
      }
        // else if (category === 'admin_idv_sendtojava') {
        //   return this.getPendingIDVData(data);
      // }
      else if (category === 'pricing_management') {
        return this.getPricingManagementData(data);
      } else if (category === 'merchants_management') {
        return this.getMerchantManagementData(data);
      } else if (category === 'location') {
        return this.getPendingLocationData(data);
      } else if (category === 'feedback') {
        return this.getPendingFeedbackData(data);
      } else if (category === 'workflow') {
        return this.getWorkflowData(data);
      } else if (category === 'owner.app' || category === 'admin_idv_sendtojava') {
        return this.getPendingOwnerAppData(data);
      } else if (category === 'dashboard') {
        return this.getPendingDashboardData(data);
      } else if (category === 'makerchecker') {
        return this.getPendingMakercheckerdData(data);
      } else if (category === 'idv_operation_results' || category === 'idv_statuses' || category === 'idv') {
        return this.getPendingIdvOperationResultsdData(data);
      } else if (category === 'dynamic_forms_ekyc' || category === 'dynamic_forms_ekyb') {
        return this.getPendingDynamicFormsEkycData(data);
      }
      else if (category === 'dynamic_forms') {
        return this.getPendingDynamicFormsData(data);
      }
      else if (category === 'loans') {
        return this.getPendingLoanData(data);
      } else if (category === 'accounts') {
        return this.getPendingAccountData(data);
      } else if (category === 'web_views') {
        return this.getWebViewsData(data);
      } else if (category === 'api_token') {
        return this.getApiTokenData(data);
      } else if (category === 'menu_extensions') {
        return this.getMenuExtensionsData(data);
      } else if (category === 'visa_direct') {
        return this.getVisaDirectData(data);
      } else {
        return { pending_transaction: data[0] };
      }
    } else {
      return '';
    }
  }

  getDeleteInfoWhiteListed(data) {
    const dataToSend = {
      pending_transaction: {
        description_transaction: '',
        transaction_details: []
      }
    };

    const user = data[0]?.feature_item?.user;
    if (user?.username) {
      dataToSend.pending_transaction.transaction_details.push({
        column_name: this.translate.instant('approval.username'),
        old_value: user.username,
      });
    }
    if (user?.phone) {
      dataToSend.pending_transaction.transaction_details.push({
        column_name: this.translate.instant('approval.phone'),
        old_value: user.phone,
      });
    }

    return dataToSend;
  }
}
